import React, { useState, useEffect } from 'react';
import AddMenus from './AddMenu';
import { useAccesos } from '../contexts/AccesosContext';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

function Menus() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [menus, setMenus] = useState([]);
    const [editMenu, setEditMenu] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [menuToDelete, setMenuToDelete] = useState(null);

    const fetchMenus = async () => {
        try {
            const response = await fetch(`${server}/sg_menu`);
            const data = await response.json();
            setMenus(data.$values);
        } catch (error) {
            console.error('Error al cargar los menus:', error);
        }
    };

    useEffect(() => {
        fetchMenus();
    }, []);

    const handleNewMenu = () => {
        fetchMenus();
        setEditMenu(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleOpenDialog = (menu) => {
        setMenuToDelete(menu);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setMenuToDelete(null);
    };

    const handleDeleteMenu = async () => {
        if (menuToDelete) {
            try {
                const response = await fetch(`${server}/sg_menu/${menuToDelete.id}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchMenus(); // Recargar la lista de menús
                    alert('Menú eliminado con éxito');
                } else {
                    alert('Error al eliminar el menú');
                }
            } catch (error) {
                console.error('Error al eliminar el menú:', error);
                alert('Error al eliminar el menú');
            }
        }
    };

    const filteredMenus = menus.filter(menu => menu.nombre_menu.toLowerCase().includes(searchQuery.toLowerCase()));

    return (

        <div className="right_col" role="main">
            <div className="x_content">
                <h2>Gestion de Menus</h2>
                <br />
                <AddMenus handleNewMenu={handleNewMenu} editMenu={editMenu} />
                <div className="ln_solid" />
                <h2>Menus Existentes</h2>
                <TextField
                    label="Buscar Menú"
                    variant="outlined"
                    fullWidth
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ marginBottom: '20px' }}
                />
                <div className="table-responsive">
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <th>Nombre Menú</th>
                                    <th>Icono</th>
                                    <th>Link</th>
                                    <th>Menu Padre</th>
                                    <th>Posición</th>
                                    <th>Estado</th>
                                    <th>Acciones</th>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredMenus.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((menu) => (
                                    <TableRow key={menu.id}>
                                        <TableCell>{menu.nombre_menu}</TableCell>
                                        <TableCell>{menu.icono_menu}</TableCell>
                                        <TableCell>{menu.href}</TableCell>
                                        <TableCell>{menu.id_menu_padre}</TableCell>
                                        <TableCell>{menu.posicion}</TableCell>
                                        <TableCell>{menu.estado ? 'Activo' : 'Inactivo'}</TableCell>
                                        <TableCell>
                                            <Button color="primary" onClick={() => setEditMenu(menu)} disabled={!tienePermiso('Editar Menú')}>Editar</Button>
                                            <Button color="secondary" onClick={() => handleOpenDialog(menu)} disabled={!tienePermiso('Eliminar Menú')}>Eliminar</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={filteredMenus.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Filas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                        />
                    </TableContainer>
                    <Dialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                ¿Estás seguro de que deseas eliminar el menú seleccionado?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialog} color="primary">
                                Cancelar
                            </Button>
                            <Button onClick={handleDeleteMenu} color="primary" autoFocus>
                                Eliminar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>

            </div>
        </div>

    )
}

export default Menus;
